module.exports = __webpack_public_path__ + "67619baadbb2efe2521ef67286f5bf41.png";